// src/scripts/contact/internal/state.js

import { isBrowser, CONTACT_LOADED_KEY } from './constants.js';

// Singleton instance and its initialization promise
let instance = null;
let promise = null;

// Flags for initialization and debug mode
let initialized = false;
let debugMode = false;

// Instance getters/setters
export function getInstance() {
  return instance;
}
export function setInstance(i) {
  instance = i;
}

// Promise getters/setters
export function getPromise() {
  return promise;
}
export function setPromise(p) {
  promise = p;
}

// Initialization flag getters/setters
export function isInitialized() {
  return initialized;
}
export function setInitialized(flag) {
  initialized = flag;
}

// Debug mode flag getters/setters
export function getDebugMode() {
  return debugMode;
}
export function setDebugMode(flag) {
  debugMode = flag;
}

// Reset all state (use after failure or when reinitializing)
export function resetState() {
  instance = null;
  promise = null;
  initialized = false;
  debugMode = false;
  if (isBrowser && window[CONTACT_LOADED_KEY]) {
    delete window[CONTACT_LOADED_KEY];
    delete window.ContactSystem;
    delete window.ContactDebug;
  }
}